module.exports = __webpack_public_path__ + "static/img/medel_normal.55619df2.png";